import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form-control w-full config-list" }

import { computed, onMounted } from "vue";
import { useToast } from "vue-toastification";
import { useBackendStore, useConfigFiltersStore } from "@/stores";
import { ConfigShort } from "@/stores/backend";
import ListSelect from "@/components/utils/ListSelect.vue";

interface ConfigOption {
  id: number;
  label: string;
}

interface ConfigShortSort {
  id: number;
  name: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ConfigList',
  setup(__props) {

const toast = useToast();
const backend = useBackendStore();
const filters = useConfigFiltersStore();

const label = (c: ConfigShort): string =>
  c.owner != null ? `${c.name} @${c.owner_name}` : c.name;

const currentLabel = computed(() => {
  if (backend.currentConfig == null) return "__default__";
  const current = backend.configList.find(
    (c) => c.id == backend.currentConfig?.id
  );
  if (current == undefined) return backend.currentConfig.name;
  return current.name;
});

const configSortKey = (a: ConfigShortSort, b: ConfigShortSort) => {
  // Prioritize default config as the first one (by name, as ID may not be the lowest one)
  if (a.name !== b.name) {
    if (a.name === "DEFAULT") return -1;
    if (b.name === "DEFAULT") return Infinity;
  }
  // Then sort by ID
  return a.id - b.id;
};

const configurations = computed(() => {
  return backend.configList
    .map((c) => ({
      id: c.id,
      owner: c.owner,
      label: label(c),
      name: c.name,
    }))
    .filter(
      (c) => filters.owned == false || c.owner == backend.user?.id?.toString()
    )
    .sort(configSortKey);
});

const selectConfig = (c: ConfigOption) => {
  backend.setCurrentConfig(c.id);
  //.then(() => (currentLabel.value = c.label));
};

onMounted(() =>
  backend.fetchConfigList().then((configs) => {
    // Select default config
    if (configs.length == 0) {
      toast.error("Could not retrieve any configurations from server");
    } else {
      const defaultConfig = configs.sort(configSortKey)[0];
      selectConfig({ id: defaultConfig.id, label: label(defaultConfig) });
    }
  })
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ListSelect, {
      modelValue: currentLabel.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = (c) => selectConfig(c)),
      options: configurations.value,
      clearable: false
    }, null, 8, ["modelValue", "options"])
  ]))
}
}

})